import { render } from "./ContainerTabs.vue?vue&type=template&id=007f233c&scoped=true"
import script from "./ContainerTabs.vue?vue&type=script&lang=js"
export * from "./ContainerTabs.vue?vue&type=script&lang=js"

import "./ContainerTabs.vue?vue&type=style&index=0&id=007f233c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007f233c"]])

export default __exports__